import EditorModalStaticBackground from './EditorModalStaticBackground';

export default EditorModalStaticBackground;
